import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '../../lib/utils'

// Square, monospaced, one accent. Hover moves the border to anodize rather than
// shifting fill or elevation (appendix A §A5).
const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap border font-mono transition-[color,background-color,border-color] duration-150 disabled:pointer-events-none disabled:opacity-55 [&_svg]:size-3.5 [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        primary: 'border-[var(--ink)] bg-[var(--ink)] text-[var(--bone)] hover:border-[var(--anodize)]',
        accent: 'border-[var(--ink)] bg-[var(--ink)] text-[var(--bone)] hover:border-[var(--anodize)]',
        outline: 'border-[var(--rule)] bg-transparent text-[var(--ink)] hover:border-[var(--anodize)] hover:text-[var(--anodize)]',
        ghost: 'border-transparent bg-transparent text-[var(--ink-2)] hover:text-[var(--anodize)]',
        danger: 'border-[var(--danger)] bg-transparent text-[var(--danger)] hover:bg-[var(--danger)] hover:text-[var(--bone)]',
      },
      size: {
        sm: 'min-h-8 px-3 text-xs',
        md: 'min-h-10 px-4 text-[13px]',
        lg: 'min-h-11 px-5 text-[13px]',
        icon: 'size-10 p-0',
      },
    },
    defaultVariants: { variant: 'primary', size: 'md' },
  },
)

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, ...props }, ref) => (
    <button ref={ref} className={cn(buttonVariants({ variant, size }), className)} {...props} />
  ),
)
Button.displayName = 'Button'

export { buttonVariants }
